import { render, staticRenderFns } from "./ManageLoginSecurity.vue?vue&type=template&id=ba52464e&scoped=true&"
import script from "./ManageLoginSecurity.vue?vue&type=script&lang=js&"
export * from "./ManageLoginSecurity.vue?vue&type=script&lang=js&"
import style0 from "./ManageLoginSecurity.vue?vue&type=style&index=0&id=ba52464e&lang=scss&scoped=true&"
import style1 from "./ManageLoginSecurity.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba52464e",
  null
  
)

export default component.exports